import { accountApi } from "@/api/account";
import { authApi } from "@/api/auth";
import { paymentAndPlanApi } from "@/api/payment-and-plan";
import { reportApi } from "@/api/report";
import { Zodios, makeApi } from "@zodios/core";

export const endPoint = `${process.env.NEXT_PUBLIC_BACKEND_URL}/api`;
const api = makeApi([...accountApi, ...authApi, ...paymentAndPlanApi, ...reportApi]);

export const apiClient = new Zodios(endPoint, api, {
  axiosConfig: {
    headers: {
      "content-type": "application/json"
    },
    withCredentials: true
  }
});

export { _fetchMe as fetchMe, _fetchProfile as fetchProfile } from "@/api/account";
export { _fetchCurrentPlan as fetchCurrentPlan } from "@/api/payment-and-plan";
